<template>
  <div class="sub-container">
    <new-subscription-modal :subscription="subscription" :active="showSubscriptionModal"
                            @refreshsubscription="refreshSubscription" :intro="intro"></new-subscription-modal>

    <new-waitlist-modal :subscription="subscription" :active="showWaitlistModal"
                        @refreshsubscription="refreshSubscription"></new-waitlist-modal>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionModalContainer',

  props: {
    intro: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      subscription: null,
      showSubscriptionModal: false,
      showWaitlistModal: false
    }
  },

  mounted() {
    this.$events.$on('OpenNewSubscription', (subscription) => {
      this.subscription = subscription
      if (subscription.$waitlist) {
        this.showWaitlistModal = !this.showWaitlistModal
      } else if (subscription.$subscription) {
        this.showSubscriptionModal = !this.showSubscriptionModal
      } else if (subscription.product.subscription) {
        this.showSubscriptionModal = !this.showSubscriptionModal
      } else if (subscription.product.waitlist) {
        this.showWaitlistModal = !this.showWaitlistModal
      }
    })
  },

  methods: {
    refreshSubscription(id) {
      const url = (this.subscription.product.waitlist === 1 || this.subscription.$waitlist) ? `waitlistsubscriptions/${id}` : `subscriptions/${id}`
      this.axios.get(url)
        .then(({data}) => {
          this.subscription.product.fields = data.product.fields
          this.subscription.accessories = data.accessories
          this.subscription.pricing_plans = data.pricing_plans
        }).catch()
    }
  },

  beforeDestroy() {
    this.$events.$off('OpenNewSubscription')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subscription/SubscriptionModalContainer.vue